import Button from '@components/ui/button.vue';
import Count from '@components/ui/count.vue';

import { mapMutations, mapGetters } from 'vuex';

export default {
  data: function() {
    return {
      items: [],
    };
  },
  components: {
    't-button': Button,
    't-count': Count,
  },
  methods: {
    ...mapMutations('cart', ['addItemToCart']),
    ...mapGetters('cart', ['checkInCart']),
    buttonContent: function(id) {
      return this.checkInCart()(id) ? 'В корзине' : 'В корзину';
    },
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/products-grid/script.js